import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ConstitutionDayCelebration = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg14.jpg" },
  { img: "/assets/img/SOL/event/event1_mg15.jpg" }, 
  
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Constitution Day Celebration - 26th November 2024" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>The Constitution Day celebration at MVN University, held on 26th November 2024 was organized by the Constitutional Law Club under the theme "Celebrating the Spirit of Constitutional Democracy." The event aimed to promote constitutional literacy and highlight the significance of the Indian Constitution.</p>
          
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ConstitutionDayCelebration;
